import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { colors } from '../lib/theme';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen text-slate-100" style={{ backgroundColor: colors.bgPrimary }}>
      <header
        className="sticky top-0 z-30 w-full backdrop-blur-sm"
        style={{
          borderBottom: `1px solid ${colors.border}`,
          backgroundColor: `${colors.bgSecondary}80`,
        }}
      >
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 text-sm hover:opacity-80 transition-opacity"
            style={{ color: colors.textSecondary }}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to screener
          </Link>
          <span className="font-semibold tracking-tight" style={{ color: colors.textPrimary }}>
            Privacy
          </span>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        <section>
          <h1 className="text-3xl font-bold" style={{ color: colors.textPrimary }}>
            Privacy
          </h1>
          <p className="mt-4 leading-relaxed" style={{ color: colors.textSecondary }}>
            EthicCheck MVP does not require an account. This page describes what we handle when you
            use the public screener.
          </p>
        </section>

        <section className="space-y-4">
          <PrivacyBlock title="Portfolio screening">
            When you paste tickers or upload a CSV, symbols are sent to our API to run screening.
            We do not store your portfolio as a saved account feature in MVP 1. Requests may be
            logged for operations and debugging on the server side.
          </PrivacyBlock>
          <PrivacyBlock title="Waitlist">
            If you join the waitlist, we store your email to send launch updates. You can ask to be
            removed by contacting us.
          </PrivacyBlock>
          <PrivacyBlock title="What we do not do (MVP 1)">
            No brokerage login, no persistent saved portfolios, no sale of personal data. We do not
            track you across other websites for advertising.
          </PrivacyBlock>
          <PrivacyBlock title="Third parties">
            Screening uses our backend and database (Supabase). Hosting providers may process request
            metadata (IP, timestamps) under their standard policies.
          </PrivacyBlock>
        </section>
      </main>
    </div>
  );
}

function PrivacyBlock({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div
      className="rounded-xl p-5"
      style={{
        border: `1px solid ${colors.border}`,
        backgroundColor: colors.bgSecondary,
      }}
    >
      <h2 className="font-semibold" style={{ color: colors.textPrimary }}>
        {title}
      </h2>
      <p className="mt-2 text-sm leading-relaxed" style={{ color: colors.textSecondary }}>
        {children}
      </p>
    </div>
  );
}
